import styled from "styled-components";

const PageWrapperStyles = styled.div`
  .content-container {
    display: flex;
    flex-direction: column;

    ${props => props.theme.media.lg} {
      display: grid;
      grid-template-columns: 3fr 1fr;
      grid-gap: 2rem;      
    }
  }

`;

export default PageWrapperStyles;